<template>
<a href="/">
    <div class="logo" href="/" >
     
    </div>
</a> 
<div  @change="changedLocale">
    
    <select class="locale-changer" v-model="$i18n.locale">
      <option v-for="locale in $i18n.availableLocales" :key="`locale-${locale}`" :value="locale">{{ localeToName(locale) }}</option>
    </select>
  </div>
  
  <a-menu
    v-model:selectedKeys="selectedKeys"
    theme="dark"
    mode="horizontal"
    :style="{ lineHeight: '64px' }"
  >
    <a-menu-item key="1" ><a href="/#pos_solution">{{ $t('header.solution') }}</a></a-menu-item>
    <a-menu-item key="2" ><a href="/#pos_service">{{ $t('header.service') }}</a></a-menu-item>
    <a-sub-menu >
      <template #title><a href="/#pos_portfolio" style="color:inherit">{{ $t('header.portfolio') }}</a></template>
      <a-menu-item key="5"> <a href="/cases#wind"> {{ $t('home.portfolio.case1.desc') }} </a></a-menu-item>
      <a-menu-item key="6"> <a href="/cases#industrial"> {{ $t('home.portfolio.case5.desc') }} </a></a-menu-item>
      <a-menu-item key="7"> <a href="/cases#ups"> {{ $t('home.portfolio.case4.desc') }} </a></a-menu-item>

    </a-sub-menu>
    <a-menu-item key="4" ><a href="/#pos_about">{{ $t('header.about') }}</a></a-menu-item>
  </a-menu>

 

</template>

<script>

export default {
  name: "Header",
    methods: {
        changedLocale()  {
            localStorage.setItem('lang',this.$i18n.locale)
            window.document.title  = this.$t("title")
            
        },

        localeToName(locale)  {
            switch (locale) {
                case 'en':return 'English';
                case 'zh':return '中文';
                default:return locale;
            }
        }



    }
};
</script>

<style scoped>
.locale-changer {
  float:right;
  width: 80px;
  height: 31px;
  margin: 16px auto;
  vertical-align: middle;
  z-index: 10;
  position: relative;
  background-color:rgba(255, 255, 255, 0.2);
  color:gainsboro
}

.logo {
  float: left;
  width: 150px;
  height: 31px;
  margin: 16px;
  background-image: url('/statics/images/logo.png');
  background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
background-position-y: center;
  z-index: 10;
  position: relative;
  cursor: pointer;
}
</style>
